export const getAccesstoken = async () => {
  if (window.localStorage.getItem('user')) {
    const user = JSON.parse(window.localStorage.getItem('user'))
    return user.accessToken
  }
}